import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { StyledLabel } from 'styles/styledGlobal'

const StyledTotal = styled(StyledLabel)`
  margin-right: 32px;
`

interface IProps {
  totalRecord?: number
}
const TotalRecord = (props: IProps) => {
  const { totalRecord } = props
  const { t } = useTranslation()
  return (
    <StyledTotal>
      <span>{`${t('total')}: `}</span>
      <span> {totalRecord}</span>
    </StyledTotal>
  )
}

export default TotalRecord
